/* Svensk katalog for locale-support-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('sv', {
  'nav.support': 'Support',
  'navhelp.support': 'Se och följ upp supportärenden du har skickat in.',
  'route.support': 'Support',
  'support.title': 'Support',
  'support.contact': 'Kontakta support',
  'support.close': 'Stäng',
  'support.send': 'Skicka',
  'support.sending': 'Skickar…',
  'support.editor.toolbar': 'Meddelandeformatering',
  'support.editor.bold': 'Fet',
  'support.editor.italic': 'Kursiv',
  'support.editor.underline': 'Understruken',
  'support.editor.bullets': 'Punktlista',
  'support.editor.numbered': 'Numrerad lista',
  'support.editor.list': 'Lista',
  'support.editor.link': 'Länk',
  'support.editor.linkPrompt': 'Klistra in en http://- eller https://-länk',
  'support.editor.image': 'Bild',
  'support.editor.screenshot': 'Skärmbild',
  'support.editor.screenshotLabel': 'Bifoga en skärmbild av aktuell vy',
  'support.editor.capturing': 'Tar skärmbild…',
  'support.editor.pendingImages': 'Bilder redo att skickas',
  'support.editor.removeImage': 'Ta bort bild',
  'support.editor.openImage': 'Öppna bild',
  'support.editor.optimizing': 'Optimerar bilder…',
  'support.retry': 'Försök igen',
  'support.back': 'Tillbaka till supportärenden',
  'support.category': 'Kategori',
  'support.category.feil': 'Fel / något fungerar inte',
  'support.category.fakturering': 'Fakturering och betalning',
  'support.category.sporsmal': 'Allmän fråga',
  'support.category.annet': 'Annat',
  'support.subject': 'Ämne',
  'support.subject.placeholder': 'Kort beskrivning av ärendet',
  'support.message': 'Meddelande',
  'support.message.placeholder': 'Beskriv vad som händer, gärna med detaljer',
  'support.sent.title': 'Supportärendet har skickats',
  'support.sent.text': 'Vi har tagit emot {id} och hör av oss så snart som möjligt.',
  'support.new.title': 'Nytt supportärende',
  'support.new.action': 'Nytt supportärende',
  'support.filter.label': 'Filtrera supportärenden',
  'support.filter.all': 'Alla',
  'support.filter.open': 'Öppna',
  'support.filter.closed': 'Stängda',
  'support.table.ticket': 'Ärende',
  'support.table.category': 'Kategori',
  'support.table.sent': 'Skickat',
  'support.table.lastReply': 'Senaste svar',
  'support.lastReply.you': 'Du',
  'support.lastReply.support': 'Support',
  'support.table.status': 'Status',
  'support.status.open': 'Öppet',
  'support.status.closed': 'Stängt',
  'support.opened': 'Öppnat {date}',
  'support.closeTicket': 'Markera som stängt',
  'support.table.actions': 'Åtgärder',
  'support.delete.rowAction': 'Ta bort',
  'support.delete.rowLabel': 'Ta bort ärende {{id}}',
  'support.delete.action': 'Ta bort ärende',
  'support.delete.title': 'Ta bort ärendet?',
  'support.delete.confirm': 'Ta bort',
  'support.delete.text': 'Ärendet tas bort från din lista, och meddelandena i det blir inte längre tillgängliga för dig.',
  'support.delete.done': 'Ärendet har tagits bort.',
  'support.error.delete': 'Ärendet kunde inte tas bort. Försök igen.',
  'support.reopen.action': 'Öppna igen',
  'support.reopen.title': 'Öppna supportärendet igen?',
  'support.reopen.confirm': 'Öppna ändå',
  'support.reopen.text': 'Öppna bara igen om det gäller samma problem som ärendet ursprungligen handlade om. Om det är ett nytt ärende, skapa hellre ett nytt supportärende.',
  'support.you': 'Du',
  'support.agent': 'Support',
  'support.reply.placeholder': 'Fortsätt samtalet – skriv ett meddelande till support',
  'support.closed.note': 'Det här ärendet är stängt. Du kan se historiken, men inte skicka fler meddelanden.',
  'support.empty.title': 'Inga supportärenden än',
  'support.empty.filterTitle': 'Inga ärenden i det här filtret',
  'support.empty.text': 'Ärenden du skickar in via supportknappen visas här.',
  'support.loading.list': 'Hämtar supportärenden…',
  'support.loading.thread': 'Hämtar samtalet…',
  'support.error.required': 'Ange både ämne och meddelande.',
  'support.error.noBusiness': 'Välj ett företag innan du kontaktar support.',
  'support.error.create': 'Kunde inte skicka supportärendet. Försök igen.',
  'support.error.list': 'Kunde inte hämta supportärendena.',
  'support.error.thread': 'Kunde inte hämta samtalet.',
  'support.error.reply': 'Kunde inte skicka meddelandet. Försök igen.',
  'support.error.status': 'Kunde inte uppdatera statusen.',
  'support.error.link': 'Ange en giltig http://- eller https://-länk.',
  'support.error.imageType': 'Använd bilder i JPEG-, PNG-, GIF- eller WebP-format.',
  'support.error.imageSourceSize': 'Varje originalbild får vara högst 20 MB.',
  'support.error.imageSourceTotal': 'Originalbilderna får vara högst 40 MB per val.',
  'support.error.imageCount': 'Du kan bifoga upp till fyra bilder.',
  'support.error.imageSize': 'En bild är fortfarande större än 5 MB efter optimering.',
  'support.error.imageTotal': 'Optimerade bilder får vara högst 10 MB per meddelande.',
  'support.error.imageOptimize': 'Bilden kunde inte optimeras. Prova en mindre bild.',
  'support.error.screenshot': 'Kunde inte ta skärmbilden. Försök igen eller bifoga en bild manuellt.',
  'support.error.imagesUnavailable': 'Bildskickning kräver den uppdaterade supporttjänsten. Ladda om och försök igen.',
  'support.error.requestTimedOut': 'Supporttjänsten svarade inte. Försök igen.',
  'support.page.tickets': 'Supportärenden',
  'support.page.articles': 'Artiklar',
  'support.articles.back': 'Tillbaka till artiklar',
  'support.articles.search.label': 'Sök i hjälpartiklar',
  'support.articles.categories': 'Kategorier',
  'support.articles.results': 'Artiklar hittade: {count}',
  'support.articles.empty.title': 'Hittade inga artiklar',
  'support.articles.empty.text': 'Prova ett annat sökord eller välj en annan kategori.',
  'support.articles.clear': 'Återställ sökning och filter',
  'support.pages.label': 'Välj supportsida',
  'support.articles.search.placeholder': 'Sök i hjälpartiklar',
  'support.articles.count.one': '{count} artikel',
  'support.articles.count.other': '{count} artiklar',
  'support.articles.resultsTitle': 'Sökresultat',
  'err.nativeValidation.backend-support.1': 'Ogiltigt svar vid borttagning av supportärendet.',
});
